$.fn.SideCtas = function(stage) {
  let self = this
  self.stage = stage
  self.ctas = self.find('.side-cta-row')
  self.active_item = 'none'

  self.ctas.each(function(index) {
    $(this).attr('side-cta-id', index)
    $(this).find('.side-cta').attr('side-cta-id', index)
    let sideCTA = $(this).find('.side-cta').clone()
    sideCTA.appendTo(self.stage)
    sideCTA.find('form.cart').each(function() {
      $(this).CartForm()
    })
  })

  self.display_cta = function() {
    // mobile
    self.find('.side-cta[side-cta-id=' + self.active_item + ']').addClass('--show')

    // Desktop
    var delay = 0
    if (self.stage.find('.side-cta.--show').length) {
      delay = 300
      self.stage.find('.side-cta.--show').removeClass('--show').addClass('--hide')
    }
    self.stage.find('.side-cta[side-cta-id=' + self.active_item + ']').removeClass('--hide').addClass('--prep')

    // Manage table of content height
    $('.table-of-contents').css('--max-height', $('.table-of-contents__list').outerHeight() + 'px')
    if (self.active_item != 'none') {
      if (!$('.table-of-contents').hasClass('--closed')) {
        delay = 300
      }
      $('.table-of-contents').addClass('--closed')
    } else {
      $('.table-of-contents').removeClass('--closed')
    }

    const myTimeout = setTimeout(function() {
      if (self.active_item != 'none') {
        self.stage.find('.side-cta').css('display', 'none')
        self.stage.find('.side-cta[side-cta-id=' + self.active_item + ']').css('display', 'block')
        const myTimeout2 = setTimeout(function() {
          self.stage.find('.side-cta[side-cta-id=' + self.active_item + ']').removeClass('--prep').addClass('--show')
        }, 100)
      }
    }, delay)
  }

  self.init_scroll = function() {
    $.mlmi.scroll.add(function(top) {
      self.new_active_item = 'none'
      self.windowTrigger = (window.innerHeight || document.documentElement.clientHeight) / 2
      self.ctas.each(function(index) {
        var rect = $(this)[0].getBoundingClientRect()
        if (rect.top < self.windowTrigger) {
          self.new_active_item = $(this).attr('side-cta-id')
          if ($(this).find('.side-cta').hasClass('--hide-section-end')) {
            var section_rect = $(this).closest('.page-section')[0].getBoundingClientRect()
            if (section_rect.bottom < self.windowTrigger) {
              self.new_active_item = 'none'
            } else {
              self.new_active_item = $(this).attr('side-cta-id')
            }
          } else {
            self.new_active_item = $(this).attr('side-cta-id')
          }
        }
      })
      if (self.new_active_item != self.active_item) {
        self.active_item = self.new_active_item
        self.display_cta()
      }

    })
  }

  self.init_main_cta = function() {
    if ($('.blog-post-product-cta').length) {
      $.mlmi.mobile.add(function() {
        $('.table-of-contents').after($('.blog-post-product-cta').detach())
      }, function() {
        $('.single-post__product-cta > .container:first').append($('.blog-post-product-cta').detach())
      })
    }
  }

  return function() {
    self.init_scroll()
    self.init_main_cta()
    return self
  }()
}
